module.exports = __webpack_public_path__ + "img/var_int.0702073.svg";